<template>
  <div>
    <b-card bg-variant="light"
            header="Proposals"
            header-bg-variant="dark"
            header-text-variant="white">
      <b-tabs v-model="selectedCard" card>
        <b-tab lazy title="Proposals list">
          <proposals-list :fields="fields"/>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
  import proposalsList from '@/components/operational/proposals/ProposalsList';
  import { ordinalNumber } from '@/helpers/commonTableColumns';

  export default {
    name: 'ProposalsDashboard',
    components: { proposalsList },
    data() {
      return {
        selectedCard: 1,
        fields: [
          ordinalNumber,
          {
            key: 'document_specification.document_id',
            label: 'ID',
            sortable: true,
            class: 'custom-column-id-width',
          },
          {
            key: 'title',
            label: 'Title',
            sortable: true,
          },
          {
            key: 'author',
            label: 'Author',
            sortable: true,
            class: 'custom-break-col-md',
          },
          {
            key: 'states.name',
            label: 'State',
            sortable: true,
          },
          {
            key: 'general.end_station',
            label: 'End Station',
            sortable: true,
          },
          {
            key: 'document_specification.subtypes',
            label: 'Sub- types',
            sortable: true,
            thStyle: { width: '5%' },
          },
          {
            key: 'requested_shifts',
            label: 'Re- quested shifts',
            tdClass: 'text-center',
            sortable: true,
            thStyle: { width: '5%' },
          },
          {
            key: 'granted_shifts',
            label: 'Grant- ed shifts',
            tdClass: 'text-center',
            sortable: true,
            thStyle: { width: '5%' },
          },
          {
            key: 'affiliation_data.country',
            label: 'Affiliation country',
            sortable: true,
          },
          {
            key: 'affiliation_data.city',
            label: 'Affiliation city',
            sortable: true,
          },
          {
            key: 'affiliation_data.name',
            label: 'Affiliation name',
            sortable: true,
          },
          {
            key: 'general.discipline',
            label: 'Discipline',
            sortable: true,
          },
          {
            key: 'acceptance_mark',
            label: 'Proposal status',
            sortable: true,
          },
          {
            key: 'states.date',
            label: 'Date',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Actions',
          },
        ],
      };
    },
  };
</script>

<style scoped>
  .card {
    margin: 2rem;
  }
</style>
